import styled from 'styled-components';

import { getSpace } from '@yoweb/ui/styles/utils/theme';
import { pxToRem } from '@yoweb/ui/styles/utils';

export const Ul = styled.ul`
  margin-left: ${pxToRem(40)};
  list-style: disc;

  li {
    margin-top: ${getSpace('normal1')};
  }
`;
